<template>
      <form>
        <!-- Horários -->
        <vs-row>
          <vs-col vs-type="flex" vs-lg="4" vs-md="6" vs-xs="12" >
            <div>
              <p class="label">* Acompanhante</p>
              <v-select
                :options="companionOptions" 
                @search="fetchCompanionOptions"
                v-model="selectedCompanion"
                :reduce="companionOptions => companionOptions" 
                @input="setCompanion"
                placeholder="digite aqui..."
                label="name"
                name="selectedCompanion"
                v-validate="'required'">
              </v-select>
              <span class="text-danger text-sm" v-show="errors.has('selectedCompanion')">{{ errors.first('selectedCompanion') }}</span>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-lg="4" vs-md="6" vs-xs="12" >
            <div>
              <label for="" class="vs-input--label">* Parentesco</label>
              <ul class="demo-alignment">
                <li>
                  <vs-radio v-model="companionType" vs-value="Father">Pai</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="companionType" vs-value="Mother">Mãe</vs-radio>
                </li>
                <li>
                  <vs-radio v-model="companionType" vs-value="Others">Outros</vs-radio>
                </li>
            </ul>
          </div>
          </vs-col>

          <vs-col vs-type="flex" vs-lg="2" vs-md="6" vs-xs="12" v-if="this.companionType == 'Others'">
            <div>
              <vs-input name="companionTypeDescription" v-model="companionTypeDescription" label-placeholder="* Descrição Parentesco" v-validate="'required'"/>
              <span class="text-danger text-sm" v-show="errors.has('companionTypeDescription')">{{ errors.first('companionTypeDescription') }}</span>
          </div>
          </vs-col>
        </vs-row>

        <vs-row>
            <vs-col vs-type="flex" vs-lg="4" vs-md="6" vs-xs="12" >
              <div>
                <vs-button @click="submitForm" color="primary" type="border" icon-pack="feather" icon="icon-plus">Adicionar</vs-button>
              </div>
          </vs-col>
        </vs-row>

        <br />

        <!-- Descricao -->
        <vs-row>
            <vs-col vs-type="flex" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" >
              <div id="div-selected-companions" class="vx-col w-full vs-con-loading__container">
                <vs-list>
                  <vs-list-header title="Selecionados"></vs-list-header>
                    <vs-list-item v-for="(listItem, index) in companionsSelected" :key="index" :title="listItem.companion.name" :subtitle="listItem.companionTypeDescription">
                      <vs-button @click="remove(listItem.id)" radius color="danger" type="filled" icon-pack="feather" icon="icon-x" size="small"></vs-button>
                    </vs-list-item>
                </vs-list>
              </div>
            </vs-col>
        </vs-row>
      </form>
</template>

<script>
import vSelect from 'vue-select';
import { Validator } from 'vee-validate';

import CompanionService from '../../../services/CompanionService';
import AppointmentCompanionService from '../../../services/AppointmentCompanionService';

const dict = {
  custom: {
    companionTypeDescription: {
      required: 'Informe o parentesco.',
    },
    selectedCompanion: {
      required: 'Informe o acompanhante.',
    },
  }
};

Validator.localize('en', dict);

export default {
  components: {
    vSelect,
    Validator,
    CompanionService,
    AppointmentCompanionService
  },
  data() {
    return {
      notifications: 
      {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      idAppointment: 0,
      selectedCompanion : '',
      idCompanion: 0,
      companionType: 'Mother',
      companionTypeDescription: null,
      companionOptions: [
      ],
      companionsSelected: [
      ],
    }
  },
  mounted: function () {
    this.getCompanions();
  },
  created () {
    this.idAppointment = this.$route.params.id;
  },
  methods: {
    async fetchCompanionOptions (search, loading) {
      loading(true);

      if(search.length >= 2)
      {
        var payload = {
          data: {
            name: search,
          },
          notifications: this.notifications
        };

        var result = await CompanionService.search(payload);

        this.companionOptions = result.data;
      }

      loading(false);
    },
    async getCompanions()
    {
      this.openLoadingInDiv('div-selected-companions');

      const payload = {
        data: {
          idAppointment: this.idAppointment,
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = false;
      payload.notifications.showError = false;

      var result = await AppointmentCompanionService.search(payload);
      if(result.status == 200)
      {
        this.companionsSelected = result.data;
      }

      this.$vs.loading.close('#div-selected-companions > .con-vs-loading');
    },
    async setCompanion(companion) {
      if(companion != null) {
        this.idCompanion = companion.id;
      }
    },
    async submitForm() {
     this.$validator.validateAll().then(result => {
       console.log(result);
       console.log(this.errors);
        if (result) {
          this.add();
        } else {
          // form have errors
        }
      });
    },
    async add() {
      const payload = {
        data: {
          id: 0,
          idAppointment: this.idAppointment,
          idCompanion: this.idCompanion,
          CompanionType: this.companionType,
          CompanionTypeDescription: this.companionTypeDescription,
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentCompanionService.create(payload);

      this.getCompanions();
    },
    async remove(id) {
      const payload = {
        data: {
          id: id,
        },
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await AppointmentCompanionService.remove(payload);
      this.getCompanions();
    },
    openLoadingInDiv(divId){
      this.$vs.loading({
        container: '#' + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close('#' + divId + ' > .con-vs-loading');
    }
  }
}
</script>

<style scoped>
  .label {
    padding-left: 5px;
    padding-top: 5px;
    font-size: .85rem;
    color: rgba(0,0,0,.7);
  }

  .v-select {
    min-width: 250px;
  }
</style>